import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: localStorage.getItem('authToken') || null,
    isAuthenticated: !!localStorage.getItem('authToken'),
    user: JSON.parse(localStorage.getItem('authUser')) || null,
    role: JSON.parse(localStorage.getItem('authUser'))?.role || null,
  },
  reducers: {
    login: (state, action) => {
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.role = action.payload.user.role;
    },
    logout: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      state.user = null;
      state.role = null;
    },
    // New reducer for loading the user from localStorage
    loadUserFromLocalStorage: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.role = action.payload.role; // Ensure role is updated as well
    },
  },
});

export const { login, logout, loadUserFromLocalStorage } = authSlice.actions;
export default authSlice.reducer;